import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi } from '../../api/crm';

export function SegmentationDashboardPage() {
  const [segments, setSegments] = useState<unknown[]>([]);

  useEffect(() => {
    void crmApi.listSegments().then(setSegments);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Segmentation dashboard</h1>
      <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(segments, null, 2)}</pre>
    </div>
  );
}
